import styled from "styled-components";

export const OrdersContainer = styled.div`
  padding: 10px 16px;
  padding-top: 60px;
  max-width: 700px;
  margin: 0 auto;
`;

export const OrdersHeading = styled.div`
  padding-top: 20px;
  padding-bottom: 10px;
  margin: 0;
  font-family: Rubik;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  text-align: left;
  color: #178e1c;
`;
